exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.v-breadcrumbs{padding:12px 15px\n}\n", "", {"version":3,"sources":["/app/src/common/layout/AppBreadcrumbs.vue"],"names":[],"mappings":";AAkBA,eACE,iBAAkB;CACnB","file":"AppBreadcrumbs.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.v-breadcrumbs {\n  padding: 12px 15px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-414b1ac9","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/common/layout/AppBreadcrumbs.vue
// module id = hh0j
// module chunks = 0